import { API } from 'api/config'
import { AxiosError } from 'axios'
import { MessageResponse } from 'interfaces'

interface User {
	id: number
	email: string
}

export interface UsersResponse {
	users: User[]
}

export const reminderEmailPost = async (
	organizationId: number,
	body: UsersResponse
): Promise<MessageResponse | null> => {
	try {
		const response = await API().post(
			`/send_email/login_reminder/${organizationId}`,
			body
		)
		if (response?.data) return { ...response.data.message }

		throw new Error('An error occurred reminder user')
	} catch (error) {
		const axiosError = error as AxiosError
		throw new Error(axiosError.message ?? 'An error occurred reminder user')
	}
}
